/**
 * コンバージョンメニューを非表示にする機能
 *
 * @param  {HTMLElement} root ルートとなる要素
 * @param  {Object} options   設定の変更をする際のオブジェクト
 * @return {Viod}
 */
export default (root, options) => {
    const setting = {
        className: {
            footer: 'l-footer',
            button: 'p-conversion__close',
            altText: 'u-altText',
            close: 'is-close'
        },
        text: '非表示にする'
    };
    const config = Object.assign(setting, options);
    const footer = document.querySelector(`.${config.className.footer}`);

    const method = {
        /**
         * init - 初期化
         * @return {Void}
         */
        init() {
            // ルートとなる要素がなければ何もしない
            if (!root) {
                return;
            }

            const closeButton = document.createElement('button');

            closeButton.type = 'button';
            closeButton.classList.add(config.className.button);
            closeButton.insertAdjacentHTML('beforeend', `<span class="${config.className.altText}">${config.text}</span>`);
            closeButton.addEventListener('click', method.close);

            root.insertAdjacentElement('beforeend', closeButton);
        },
        /**
         * close - 閉じる処理
         * @return {Void}
         */
        close() {
            // 閉じている場合、何もしない
            if (root.classList.contains(config.className.close)) {
                return;
            }

            footer.setAttribute('data-conversion-closed', 'true');
            root.classList.add(config.className.close);
        }
    };

    // 初期化を実行
    method.init();
};
